module.exports = __webpack_public_path__ + "static/media/blood2.1efb7fc3.svg";